module.exports = __webpack_public_path__ + "img/academy.4436ae8f.jpg";